<template lang="pug">
.container.col-centered
  .row
    h2.main_title
      | Firmware
      .pull-right
        button.btn.btn-primary(v-on:click="handleShowModal('upload')" v-if="user.role === 'admin'")
          span.glyphicon.glyphicon-plus
          span  New
        button.btn.btn-default(@click="showUpgradeGuide = true" style="margin-left: 8px;")
          span.glyphicon.glyphicon-book
          span  Upgrade Guide
    .col-md-12.function_bar(style="display:flex; justify-content: space-between; align-items: center;")
      //- .form-group(v-bind:class="{'col-md-3': $route.name === 'switch', 'col-md-2': $route.name === 'smart-controller'}")
        label.control_label
          | Date:
        v-select(v-bind:value.sync='logFilter.date.value' v-bind:options='logFilter.date.opts')
      .form-group
        label.control_label
          | Search:
        tooltip(effect="scale" placement="bottom" content="Search by version or release notes")
          input.form-control(v-model="temporarySearchQuery" @keydown.enter="applySearchQuery" placeholder="Search..." style="display: inline-block; width: auto; vertical-align: middle;")
      .form-group(v-bind:class="{'col-md-4': $route.name === 'switch', 'col-md-3': $route.name === 'smart-controller'}")
        label.control_label
          | Category:
        v-select(v-bind:value.sync='logFilter.category.value' v-bind:options='logFilter.category.opts')
      .form-group.col-md-3(v-if="$route.name === 'smart-controller'")
        label.control_label
          | Domain:
        v-select(v-bind:value.sync='logFilter.domain.value' v-bind:options='logFilter.domain.opts')
      .form-group.col-md-2(v-if="$route.name === 'smart-controller'")
        label.control_label
          | Model:
        v-select(v-bind:value.sync='logFilter.model.value' v-bind:options='logFilter.model.opts')
      //- .form-group(v-bind:class="{'col-md-4': $route.name === 'switch', 'col-md-2': $route.name === 'smart-controller'}")
        //- label.control_label
          //- | Custom:
        //- v-select(v-bind:value.sync='logFilter.custom.value' v-bind:options='logFilter.custom.opts')
      //- .form-group
        //- label.control_label
          //- | Layer:
        //- v-select(v-bind:value.sync='logFilter.layer.value' v-bind:options='logFilter.layer.opts')
      .form-group(v-bind:class="{'col-md-4': $route.name === 'switch', 'col-md-2': $route.name === 'smart-controller'}" v-if="user.role === 'admin' || isIntrising")
        label.control_label
          | Status:
        v-select(v-bind:value.sync='logFilter.status.value' v-bind:options='logFilter.status.opts')
      //- .form-group
        //- label.control_label
          //- | Spec:
        //- v-select(v-bind:value.sync='logFilter.spec.value' v-bind:options='logFilter.spec.opts')
      .form-group
        label.control_label
          | Security:
        v-select(v-bind:value.sync='logFilter.security.value' v-bind:options='logFilter.security.opts')
    spinner(v-ref:spinner size="md" show="true" text="Loading...")
    div(v-if="firmwareLoaded")
      pagination(
        v-bind:sort-method.sync="sortMethod"
        v-bind:sort-method-opts="sortMethodOpts"
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='searchFilteredTotalLog'
        v-bind:expand-all.sync='expandAll'
        v-bind:show-toggle-expansion-btn='true'
      )
      .col-md-12
        //- span {{pi | json}}
        //- span {{firmware | json}}
        //- span {{customFilteredTotalLog[0] | json}}
        //- span {{switch | json}}
        table.table.table-bordered.table-hover.log_table
          tr(v-for="($index, p) in searchFilteredTotalLog | limitBy countOfPage pageStart")
            td {{$index + 1 + pageStart}}
            td.single_log
              .media(style="overflow: visible;")
                .media-left
                  .media-object.device_icon(v-bind:class="p.category")
                    img(v-bind:src="getIconSrc(p.category)")
                .media-body(style="overflow: visible;")
                  .media-top
                    //- span {{p.updatedAt | timeFormat}}
                    span.media-top__info
                      .version-row
                        span.version
                          span(style="margin-right: 4px" v-html='highlightMatches(p.version, searchQuery)')
                          span.glyphicon.glyphicon-link(class="copy-icon" @click="copyToClipboard(p.version)" style="font-size: 14px;")
                        //- span.model.type_tag.base_black.base_grey_bg {{getCustomForUI(p.custom)}}
                        span.model.type_tag.base_black.base_white_bg(v-if="p.isReadOnly && user.role === 'admin'") ReadOnly
                        span.model.type_tag.base_black.base_white_bg(v-if="['router', 'routerx'].includes(p.category) && p.firmwareLayer != null") Layer {{ p.firmwareLayer }}
                        span.model.type_tag.base_blue.base_grey_bg(v-if="$route.name === 'smart-controller' && p.domain != null") {{p.domain}}
                      span.time
                        span.glyphicon.glyphicon-time
                        span(v-if="sortMethod.name !== 'updatedAt'") Released at {{ p.createdAt | fromNow }}
                        span(v-if="sortMethod.name === 'updatedAt'") Updated at {{ p.updatedAt | fromNow }}
                    //- span {{p.url}}
                    .action_buttons
                      .btn-group
                        button.btn.btn-sm.btn-default(@click="handleShowModal('update', p['.key'], $index)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-pencil
                        button.btn.btn-sm.btn-default(@click="handleShowDeleteConfirm(p['.key'], p.category)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-trash
                        a.btn.btn-sm.btn-default(v-if="p.category !== 'smart-controller' && p.status === 'release' || user.role === 'admin' || isIntrising" v-on:click='handleDownload(p.url, $event)' v-bind:disabled="p.url === ''")
                          span.glyphicon.glyphicon-cloud-download
                          span(v-if="$route.name === 'switch'")  Firmware
                          span(v-else)  Firmware
                        dropdown
                            button.btn.btn-sm.btn-default.dropdown-toggle(slot="button" type="button" v-bind:disabled="getObjectSize(getCompatibleMibEntries(p)) === 0")
                              span.fa.fa-download
                              span  Private MIB
                            ul.dropdown-menu(slot="dropdown-menu")
                              li(v-if="getObjectSize(getCompatibleMibEntries(p)) === 0" class="disabled")
                                a
                                  | No compatible MIBs available
                              li(v-for="(key, value) in getCompatibleMibEntries(p)" v-bind:class="{'disabled': value.version == null}")
                                a(@click="handleDownload(value.url, $event)")
                                  | {{ value.version == null ? 'None' : value.version }}
                        a.btn.btn-sm.btn-default(v-if="p.category !== 'smart-controller' && p.status === 'release' || user.role === 'admin'" v-on:click='handleDownload(p.testReportUrl, $event)' v-bind:disabled="p.testReportUrl === ''")
                          span.glyphicon.glyphicon-list-alt
                          span  Test Report
                  .media-middle
                    //- line-table(title='MD5' v-bind:content='p.md5' v-if='p.md5 != null && p.md5.length !== 0')
                    line-table(title='Model' v-bind:is-md="true" v-bind:content='p.modelTxt' v-if='p.modelTxt != null && p.modelTxt.length !== 0')
                    line-table(
                      title='Release Notes'
                      v-bind:is-md="true"
                      v-bind:default-collapse="!(searchQuery.trim() !== '' && p.releaseNote?.toLowerCase().includes(searchQuery.toLowerCase()))"
                      v-bind:content='highlightMatches(p.releaseNote, searchQuery, false)'
                      v-if='p.releaseNote && p.releaseNote.length !== 0'
                      v-bind:expand-all='expandAll'
                    )
                      span.time(slot="header-extra" v-if="p.releaseNoteUpdatedAt" style="margin-left: 8px;")
                        span.glyphicon.glyphicon-time
                        span(v-if="p.releaseNoteUpdatedBy") Updated by {{p.releaseNoteUpdatedBy}} {{p.releaseNoteUpdatedAt | fromNow}}
                        span(v-else) Updated {{p.releaseNoteUpdatedAt | fromNow}}
                    div(v-if='(user.role === "admin" || isIntrising) && p.hasInternalLog' @click="fetchInternalLog(p['.key'])")
                      line-table(
                        title='Internal Logs'
                        v-bind:is-md="true"
                        v-bind:default-collapse="true"
                        v-bind:content='internalLogs[p[".key"]] || ""'
                        v-bind:expand-all='expandAll'
                      )
            td.badge_group
              .customized__badge(v-bind:class="p.status")
                span {{p.status}}
      .col-md-12(v-if="searchFilteredTotalLog.length <= 0")
        h3.text-center.text-muted No Data
  modal(
    v-bind:title.sync='modalTitle'
    v-bind:ok-text.sync='okText'
    backdrop='false'
    v-bind:callback='modalCb'
    v-bind:show.sync='showModal')
    .modal-body.upload_modal(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .form-group.col-md-12.clearfix(v-if='isUpdate')
          .col-md-3.form_label.clearfix
            label.control_label
              | Last update:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='isUpdatedAt' readonly)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Date:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='isReleasedAt' readonly v-if="user.role !== 'admin'")
            datepicker(v-bind:value.sync="isReleasedAt" v-bind:format="'yyyy/M/dd'" placeholder="Default is current time." v-else)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Category:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='category' v-bind:value.sync='selectedCategory' v-bind:disabled="user.role !== 'admin'")
        //- .form-group.col-md-12.clearfix
          //- .col-md-3.form_label.clearfix
            //- label.control_label
              //- | Custom:
          //- .col-md-9.no_pad.clearfix
            //- v-select(v-bind:options='customOpts' v-bind:value.sync='selectedCustom' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix(v-if="selectedCategory === 'smart-controller'")
          .col-md-3.form_label.clearfix
            label.control_label
              | Domain:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='domainOpts' v-bind:value.sync='selectedDomain' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix(v-if="selectedCategory === 'smart-controller'")
          .col-md-3.form_label.clearfix
            label.control_label
              | Model:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='modelOpts' v-bind:value.sync='selectedModel' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.version
          .col-md-3.form_label.clearfix
            label.control_label
              | Version:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='version' v-bind:placeholder.sync='versionPlaceholder' v-bind:class="{'error': showInvalidMsg}" v-bind:readonly="user.role !== 'admin'")
          span.text-danger(v-if='showInvalidMsg')
            | Please follow the format of placeholder
        div(v-if="$route.name === 'smart-controller'")
          .form-group.col-md-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label.download
                | Download Link:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='url' placeholder='www.google.com' v-bind:readonly="user.role !== 'admin'")
        div(v-else)
          .form-group.col-md-12.clearfix(v-if="['router', 'routerx'].includes(selectedCategory)")
            .col-md-3.form_label.clearfix
              label.control_label
                | Layer:
            .col-md-9.no_pad.clearfix
              v-select(v-bind:options="[{label: '2', value: 2}, {label: '3', value: 3}]" v-bind:value.sync='firmwareLayer' v-bind:disabled="user.role !== 'admin'")
          .form-group.col-md-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | Firmware
                |
                span.glyphicon.glyphicon-cloud-download
                | :
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='url' placeholder='www.google.com' v-bind:readonly="user.role !== 'admin'")
          .form-group.col-md-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | MD5 :
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='md5' placeholder='' v-bind:readonly="user.role !== 'admin'")
          .form-group.col-md-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | Test Report:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='testReportUrl' placeholder='www.google.com' v-bind:readonly="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Status:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='status' v-bind:value.sync='selectedStatus' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group(v-if='isUpdate && modelTxt')
          .col-md-3.form_label.clearfix
            label.control_label
              | Model:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='modelTxt' placeholder='' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Notes:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='releaseNote' placeholder='[TopologyView] support LLDP discover\n[EventLog  ] Cold Start Log.' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group(v-if="user.role === 'admin' || isIntrising")
          .col-md-3.form_label.clearfix
            label.control_label
              | Internal Logs:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='internalLog' placeholder='[MSTP] If VLAN trunk is not the same to each other, the topology will loop.' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group(v-if="user.role === 'admin'")
          .col-md-3.form_label.clearfix
            label.control_label(style="padding-top:4px;") Is Read Only:
          .col-md-9.no_pad.clearfix
            checkbox(:checked.sync="isReadOnlyStr" value="true")
  modal(title='Upgrade Guide' v-bind:show.sync='showUpgradeGuide' effect='fade' width='800px')
    .modal-body(slot='modal-body')
      p Firmware upgrade standard operating procedures (SOP) for each platform.
      table.table.table-bordered(style='margin-bottom: 0; table-layout: fixed;')
        colgroup
          col(style='width: 160px;')
          col
          col(style='width: 200px;')
        thead
          tr
            th Platform
            th Title
            th Download
        tbody
          tr(v-if='upgradeGuideList.length === 0')
            td.text-center.text-muted(colspan='3') No upgrade guides available.
          tr(v-for='doc in upgradeGuideList')
            td.text-vcenter(style='white-space: normal; word-break: break-word;') {{guideProductList(doc).join(', ')}}
            td.text-vcenter(style='white-space: normal; word-break: break-word;') {{doc.title}}
            td.text-center
              button.btn.btn-sm.btn-default(@click='handleDownload(doc.url, $event)' v-bind:disabled='!doc.url')
                span.glyphicon.glyphicon-cloud-download
                span  Download
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click='showUpgradeGuide = false') Close
  modal(
    title='Confirm'
    v-bind:show.sync='showDeleteConfirm')
    .modal-body(slot='modal-body')
      h4.text-center Are you sure to delete?
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click='showDeleteConfirm = false')
        | No
      button.btn.btn-danger(@click='applyDelete')
        | Yes
  alert(v-bind:show.sync="showAlert" placement="top" duration="5000" type="danger" width="400px" dismissable)
    span(class="icon-info-circled alert-icon-float-left")
    h4 The following fields are required:
      ul
        li(v-if="!selectedCategory") Category
        li(v-if="!url") Firmware
        li(v-if="!version") Version
        li(v-if="!selectedStatus") Status
        li(v-if="!isReleasedAt") Release Date
        li(v-if="!md5") MD5
        li(v-if="md5 && md5.length !== 32") MD5 must be 32 characters
</template>
<script>
import moment from 'moment'
import { alert, datepicker, dropdown, modal, select, spinner, checkbox, tooltip } from 'vue-strap'
import pagination from '../common/Pagination.vue'
import lineTable from '../common/LinedTable.vue'
import { getDb, getFireBase, getCustomForUI, getIconSrc, filterOptions, naturalSorting, resolveDownloadUrl, getLabelFromCategory, isSwitchCategory } from '../../index.js'
import searchMixin from '../../mixins/searchMixin.js'
import permissionsMixin from '../../mixins/permissionsMixin.js'
import _ from 'lodash'

const fb = getFireBase()
const PI = 'smart-controller'
const SWITCH_CATEGORY = filterOptions.category
const PI_CATEGORY = [
  {label: 'Smart-controller', value: PI}
]
const PI_CUSTOM = [
  {label: 'Gomax', value: 'gomax'},
  {label: 'Gofanco', value: 'gofanco'}
]
const SWITCH_CUSTOM = filterOptions.custom

export default {
  mixins: [searchMixin, permissionsMixin],
  components: {
    alert,
    datepicker,
    dropdown,
    modal,
    pagination,
    'v-select': select,
    'line-table': lineTable,
    spinner,
    checkbox,
    tooltip
  },
  vuex: {
    getters: {
      user: state => state.user,
      firmwareList: state => state.firmwareList,
      firmwareLoaded: state => state.firmwareLoaded
    }
  },
  data () {
    return {
      sampleMIBs: [],
      mibEntries: [],
      dynamicTitle: '',
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      sortMethod: {
        name: 'createdAt',
        asc: false
      },
      sortMethodOpts: [
        {
          label: 'Sort by Release Date',
          value: 'createdAt'
        },
        {
          label: 'Sort by Update Time',
          value: 'updatedAt'
        },
        {
          label: 'Sort by Category',
          value: 'category'
        },
        {
          label: 'Sort by Version',
          value: 'version'
        }
      ],
      postFix: {
        all: '',
        ite: 'i',
        aspeed: 'a'
      },
      category: [],
      selectedCategory: PI,
      selectedCustom: 'gomax',
      selectedStatus: 'develop',
      selectedDomain: 'intri',
      selectedModel: 'all',
      version: '',
      customOpts: [],
      domainOpts: [],
      modelOpts: [],
      firmwareLayer: 2,
      url: '',
      md5: '',
      testReportUrl: '',
      modelTxt: '',
      releaseNote: '',
      originalReleaseNote: '',
      internalLog: '',
      isReadOnlyStr: '',
      showModal: false,
      modalTitle: '',
      okText: '',
      modalCb: function () {},
      editingKey: '',
      editingCategory: '',
      showDeleteConfirm: false,
      status: filterOptions.status.firmware,
      logFilter: {
        custom: {
          opts: [],
          value: 'any'
        },
        date: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: '1 month', value: 'month'}
          ],
          value: 'any'
        },
        category: {
          opts: [], // dynamic generated by $route.name
          value: 'any'
        },
        domain: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: 'Intri', value: 'intri'},
            {label: 'Eagleyes', value: 'eagleyes'},
            {label: 'EvoIP', value: 'evoip'}
          ],
          value: 'any'
        },
        model: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: 'ITE', value: 'ite'},
            {label: 'ASPEED', value: 'aspeed'}
          ],
          value: 'any'
        },
        status: {
          opts: [],
          value: 'any'
        },
        layer: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: '2', value: 2},
            {label: '3', value: 3}
          ],
          value: 'any'
        },
        spec: {
          opts: [],
          value: 'any'
        },
        security: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: 'Secure', value: 'secure'},
            {label: 'Non-secure', value: 'non-secure'}
          ],
          value: 'any'
        }
      },
      showAlert: false,
      isUpdate: false,
      isUpdatedAt: '',
      isReleasedAt: '',
      versionPlaceholder: 'V1.10.1',
      showInvalidMsg: false,
      internalLogs: {},
      temporarySearchQuery: '',
      searchQuery: '',
      initSpec: '',
      expandAll: false,
      generalLog: [],

      showUpgradeGuide: false,
      upgradeGuideList: []
    }
  },
  ready () {
    this.$refs.spinner.show()
    if (this.firmwareLoaded) {
      this.$nextTick(() => this.$refs.spinner.hide())
    }
    // set the category , model and  custom opts
    let optAny = {label: 'Any', value: 'any'}
    if (this.$route.name !== PI) {
      this.dynamicTitle = 'Switch Firmware Change Log'
      this.category = _.cloneDeep(SWITCH_CATEGORY)
      this.selectedCategory = 'swix1'
      // Start from full list, then remove restricted categories based on user
      this.logFilter.category.opts = _.cloneDeep(SWITCH_CATEGORY)

      // Hide AutoPVT for non-intrising users
      if (!this.isIntrising) {
        this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'autopvt')
      }
      this.logFilter.category.opts.unshift(optAny)
      this.logFilter.custom.opts = _.cloneDeep(SWITCH_CUSTOM)
      this.logFilter.custom.opts.unshift(optAny)
      this.logFilter.status.opts = _.cloneDeep(filterOptions.status.firmware)
      this.logFilter.status.opts.unshift(optAny)
      // this.selectedCustom = 'lantech'
      this.customOpts = SWITCH_CUSTOM
    } else {
      this.dynamicTitle = 'Smart-Controller Firmware Change Log'
      this.category = _.cloneDeep(PI_CATEGORY)
      this.selectedCategory = PI
      this.logFilter.category.opts = _.cloneDeep(PI_CATEGORY)
      this.logFilter.category.opts.unshift(optAny)
      this.logFilter.custom.opts = _.cloneDeep(PI_CUSTOM)
      this.logFilter.custom.opts.unshift(optAny)
      // this.selectedCustom = 'gomax'
      this.customOpts = PI_CUSTOM
      this.selectedModel = 'ite'
      this.modelOpts = [
        {label: 'ITE', value: 'ite'},
        {label: 'ASPEED', value: 'aspeed'}
      ]
      this.selectedDomain = 'intri'
      this.domainOpts = [
        {label: 'Intri', value: 'intri'},
        {label: 'Eagleyes', value: 'eagleyes'},
        {label: 'EvoIP', value: 'evoip'}
      ]
    }
    this.logFilter.category.value = this.$route.query.category || 'any'
    this.logFilter.custom.value = this.$route.query.custom || 'any'
    this.logFilter.layer.value = this.$route.query.layer === 'any' ? 'any' : parseInt(this.$route.query.layer) || 'any'
    this.logFilter.status.value = this.$route.query.status || 'any'
    this.initSpec = this.$route.query.spec || 'any'
    this.temporarySearchQuery = this.$route.query.search || ''
    this.searchQuery = this.$route.query.search || ''

    getDb().ref('documentation').orderByChild('type').equalTo('upgrade_guide').on('value', sn => {
      const latestByPlatform = {}
      _.forEach(sn.val(), (value, key) => {
        const platform = Object.values(value.products || {})[0]
        if (!platform || platform === 'viewer') return
        const existing = latestByPlatform[platform]
        if (!existing || (value.createdAt || 0) > (existing.createdAt || 0)) {
          latestByPlatform[platform] = value
        }
      })
      this.upgradeGuideList = Object.values(latestByPlatform)
    })

    this.getMibData('intrising')
  },
  computed: {
    parseSpec () {
      const generalLog = []
      const parseVersion = (version) => {
        if (typeof version !== 'string') return [];
        return version.split('_')
          .map(part => part.replace(/-/g, ''))   // remove hyphens
          .filter(val => /^\d{4}$/.test(val));   // keep 4-digit numbers
      };

      const allMatches = this.totalLog.flatMap(d => {
        if (this.user.role !== 'admin') {
          if (d.status === 'develop' && !this.isIntrising) return [];
        }
        let vers = parseVersion(d.version)
        if (vers.length === 0) {
          generalLog.push(d)
        }
        return vers;
      });

      return {
        parsed: [...new Set(allMatches)]
        .sort((a, b) => b - a)  // sort from largest spec num to smallest spec num
        .map(value => ({ label: value, value })),
        generalLog
      }
    },
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    totalLength () {
      return this.searchFilteredTotalLog.length
    },
    totalLog () {
      if (this.$route.name === PI) {
        return this.pi.sort((a, b) => {
          return b.updatedAt - a.updatedAt
        })
      } else {
        let swi = this.firmwareList.filter(x => isSwitchCategory(x.category))
        // // specific filter pandacom
        // if (['pandacom@lantechcom.tw', 'db@lantechcom.tw'].includes(this.user.email)) {
        //   swi = swi.filter(x => x.category === 'routerx' && ['V2.01.87', 'V4.01.18'].includes(x.version))
        // }
        const { name, asc: isAsc } = this.sortMethod
        if (name === 'version') {
          return naturalSorting(_.filter(swi, (x) => x.version), 'version', isAsc ? 'asc' : 'desc')
        } else {
          return _.orderBy(swi, [name], [isAsc ? 'asc' : 'desc'])
        }
      }
    },
    specFilteredTotalLog() {
      // On IntriHub the spec selector is hidden. Clients (customers) must only
      // ever see general firmware, so force 'general' for them regardless of the
      // (hidden) selector's default 'any' or any ?spec= URL override.
      const spec = this.user.role === 'client' ? 'general' : this.logFilter.spec.value;
      if (spec === 'any') { return this.totalLog }
      if (spec === 'general') { return this.generalLog }

      const dashedSpec = `${spec.slice(0, 2)}-${spec.slice(2, 4)}`;

      return this.totalLog.filter(p =>
        typeof p.version === 'string' && (p.version.includes(`_${spec}_`) || p.version.includes(`_${dashedSpec}_`))
      );
    },
    dateFilteredTotalLog () {
      return this.specFilteredTotalLog.filter(p => {
        return this.logFilter.date.value !== 'any' ? moment(p.updatedAt).isBetween(moment().subtract(1, 'months'), moment()) : true
      })
    },
    categoryFilteredTotalLog () {
      return this.dateFilteredTotalLog.filter(p => {
        return this.logFilter.category.value !== 'any' ? p.category === this.logFilter.category.value : true
      })
    },
    domainFilteredTotalLog () {
      return this.categoryFilteredTotalLog.filter(p => {
        return this.logFilter.domain.value !== 'any' ? p.domain === this.logFilter.domain.value : true
      })
    },
    modelFilteredTotalLog () {
      return this.domainFilteredTotalLog.filter(p => {
        return this.logFilter.model.value !== 'any' ? p.model === this.logFilter.model.value : true
      })
    },
    layerFilteredTotalLog () {
      return this.modelFilteredTotalLog.filter(p => {
        return this.logFilter.layer.value !== 'any' ? p.firmwareLayer === this.logFilter.layer.value : true
      })
    },
    securityFilteredTotalLog () {
      const sec = this.logFilter.security.value
      if (sec === 'any') { return this.layerFilteredTotalLog }
      return this.layerFilteredTotalLog.filter(p => {
        const isSecure = this.isSecureFirmware(p)
        return sec === 'secure' ? isSecure : !isSecure
      })
    },
    statusFilteredTotalLog () {
      const canSeeDevelop = this.user.role === 'admin' || this.isIntrising
      if (canSeeDevelop) {
        return this.securityFilteredTotalLog.filter(p => {
          return this.logFilter.status.value !== 'any' ? p.status === this.logFilter.status.value : typeof (_.find(this.logFilter.status.opts, {value: p.status})) !== 'undefined'
        })
      } else {
        return this.securityFilteredTotalLog.filter(p => p.status !== 'develop')
      }
    },
    customFilteredTotalLog () {
      return this.statusFilteredTotalLog
    },
    searchFilteredTotalLog () {
      if (this.searchQuery.trim() === "") { return this.customFilteredTotalLog }
      return this.customFilteredTotalLog.filter(p => {
        return p.version.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
               (p.releaseNote !== undefined && p.releaseNote.toLowerCase().includes(this.searchQuery.toLowerCase()))
      })
    },
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type,
        title,
        content
      })
    },
    handleDownload (url, e) {
      if (!url) return
      window.open(resolveDownloadUrl(url))
    },
    getCustomForUI,
    getSmartControllerClass (model) {
      switch (model) {
        case 'ite': return 'ite_color_bg'
        case 'aspeed': return 'aspeed_color_bg'
        case 'default': return 'base_black base_grey_bg'
      }
    },
    getIconSrc,
    handleShowModal (which, key, index) {
      // console.log('key', key)
      // console.log('index', index + this.pageStart)

      this.editingKey = key
      if (which === 'upload') {
        this.modalTitle = 'Add firmware'
        this.isUpdate = false
        this.okText = 'Add'
        this.internalLog = ''
        // this.selectedCustom = 'lantech_lantech'
        this.modelTxt = ''
        this.releaseNote = ''
        this.originalReleaseNote = ''
        this.version = ''
        this.firmwareLayer = 2
        this.url = ''
        this.md5 = ''
        this.testReportUrl = ''
        this.isReadOnlyStr = ''
        this.isReleasedAt = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        this.modalCb = this.applyUpload
      } else if (which === 'update') {
        this.modalTitle = 'Edit firmware'
        this.isUpdate = true
        let { updatedAt = '', createdAt = '', modelTxt = '', releaseNote = '', version, firmwareLayer, url, md5 = '', testReportUrl = '', domain = '', custom, category, status, isReadOnly = false } = this.searchFilteredTotalLog[index + this.pageStart]
        // console.log(version)
        this.isUpdatedAt = ''
        this.isUpdatedAt = moment(updatedAt).format('YYYY-MM-DD HH:mm:ss')
        this.isReleasedAt = ''
        this.isReleasedAt = moment(createdAt).format('YYYY-MM-DD HH:mm:ss')
        this.internalLog = ''
        if (this.user.role === 'admin') {
          getDb().ref('firmwareInternalLog').child('pt').child(key).once('value').then(sn => {
            this.internalLog = sn.val() || ''
          })
        }
        this.modelTxt = modelTxt
        this.releaseNote = releaseNote
        this.originalReleaseNote = releaseNote
        this.selectedCategory = category
        this.selectedDomain = domain
        this.selectedCustom = custom
        this.selectedStatus = status
        if (['router', 'routerx'].includes(category)) {
          if (firmwareLayer != null) this.firmwareLayer = firmwareLayer
          else this.firmwareLayer = 2
        }
        this.url = url
        this.md5 = md5
        this.testReportUrl = testReportUrl
        this.okText = 'Update'
        this.modalCb = this.applyUpdate
        this.version = version
        this.isReadOnlyStr = isReadOnly ? 'true' : null
      }
      this.showModal = true
    },
    handleShowDeleteConfirm (key, category) {
      this.editingKey = key
      this.editingCategory = category
      this.showDeleteConfirm = true
    },
    isVersionValid () {
      if (this.selectedModel === 'ite') {
        return this.version.startsWith('sciV')
      } else if (this.selectedModel === 'aspeed') {
        return this.version.startsWith('scaV')
      }
    },
    isSecureFirmware (p) {
      if (!['os5', 'os2_plus'].includes(p.category)) { return false }
      const m = /^V?\d+\.\d+\.(\d)/i.exec(p.version || '')
      return m ? m[1] === '0' : false
    },
    applyUpload () {
      this.showInvalidMsg = false
      if (!this.selectedCategory || !this.url || !this.version || !this.selectedStatus || !this.isReleasedAt || !this.md5 || this.md5.length !== 32) {
        this.showAlert = true
        return
      }
      let toPush = {
        customCategoryVersion: `${this.selectedCustom}_${this.selectedCategory}_${this.version}`,
        category: this.selectedCategory,
        createdAt: (new Date(this.isReleasedAt)).getTime(),
        custom: 'intrising',
        releaseNote: this.releaseNote,
        md5: this.md5,
        status: this.selectedStatus,
        testReportUrl: this.testReportUrl,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        url: this.url,
        version: this.version,
        isReadOnly: this.isReadOnlyStr === 'true'
      }
      if (['router', 'routerx'].includes(toPush.category)) {
        toPush.firmwareLayer = this.firmwareLayer
      }
      if (this.releaseNote) {
        toPush.releaseNoteUpdatedAt = fb.database.ServerValue.TIMESTAMP
        toPush.releaseNoteUpdatedBy = this.user.email
      }
      if (this.user.role === 'admin' && this.internalLog) {
        toPush.hasInternalLog = true
      }
      const newRef = getDb().ref('firmware').push(toPush)
      if (this.user.role === 'admin' && this.internalLog) {
        getDb().ref('firmwareInternalLog').child('pt').child(newRef.key).set(this.internalLog)
      }
      this.showModal = false
    },
    async applyUpdate () {
      if (this.user.role !== 'admin') return
      if (!this.selectedCategory || !this.url || !this.version || !this.selectedStatus || !this.isReleasedAt || !this.md5 || this.md5.length !== 32) {
        this.showAlert = true
        return
      }
      const releaseNoteChanged = this.releaseNote !== this.originalReleaseNote
      const update = {
        customCategoryVersion: `${this.selectedCustom}_${this.selectedCategory}_${this.version}`,
        category: this.selectedCategory,
        createdAt: (new Date(this.isReleasedAt)).getTime(),
        custom: 'intrising',
        releaseNote: this.releaseNote,
        md5: this.md5,
        // modelTxt is legacy: only present on old records. Non-empty = keep/update; empty = delete from DB.
        modelTxt: this.modelTxt || null,
        status: this.selectedStatus,
        testReportUrl: this.testReportUrl,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        url: this.url,
        version: this.version,
        isReadOnly: this.isReadOnlyStr === 'true',
        hasInternalLog: this.internalLog ? true : null
      }
      if (['router', 'routerx'].includes(this.selectedCategory)) {
        update.firmwareLayer = this.firmwareLayer
      }
      if (releaseNoteChanged) {
        update.releaseNoteUpdatedAt = fb.database.ServerValue.TIMESTAMP
        update.releaseNoteUpdatedBy = this.user.email
      }
      getDb().ref('firmware').child(this.editingKey).update(update)
      getDb().ref('firmwareInternalLog').child('pt').child(this.editingKey).set(this.internalLog || null)
      this.$set('internalLogs["' + this.editingKey + '"]', this.internalLog || '')
      this.showModal = false
    },
    applyDelete () {
      // console.log(this.editingKey)
      getDb().ref('firmware').child(this.editingKey).remove()
      if (this.user.role === 'admin') {
        getDb().ref('firmwareInternalLog').child('pt').child(this.editingKey).remove()
      }
      this.showDeleteConfirm = false
    },
    fetchInternalLog (fid) {
      if (this.user.role !== 'admin' && !this.isIntrising) return
      if (this.internalLogs[fid] !== undefined) return
      this.$set('internalLogs["' + fid + '"]', '')
      getDb().ref('firmwareInternalLog').child('pt').child(fid).once('value').then(sn => {
        this.$set('internalLogs["' + fid + '"]', sn.val() || '')
      })
    },
    prefetchVisibleInternalLogs () {
      if (this.user.role !== 'admin' && !this.isIntrising) return
      const visible = this.searchFilteredTotalLog.slice(this.pageStart, this.pageStart + this.countOfPage)
      for (const p of visible) {
        this.fetchInternalLog(p['.key'])
      }
    },
    guideProductList (doc) {
      const products = Object.values(doc.products || {})
      return products.map(v => getLabelFromCategory(v))
    },
    getMibData (custom) {
      let mibQuery = ['admin', 'vendor', 'salesperson'].includes(this.user.role)
          ? getDb().ref('privateMib/v2/entry')
          : getDb().ref('privateMib/v2/entry').orderByChild('custom').startAt(custom).endAt(custom)

      mibQuery.on(
        'value',
        (sn) => {
          this.mibEntries = _.transform(sn.val(), (result, value, key) => {
            if (this.user.role !== 'admin' && !this.isIntrising && value.status !== 'release') return
            result.push({
              '.key': key,
              ...value,
              minimaFw: value.minimaFw || ''
            })
          }, [])
        },
        () => {
          mibQuery.off()
        }
      )
    },
    updateQueryParams() {
      const query = {
        category: this.logFilter.category.value,
        custom: this.logFilter.custom.value,
        status: this.logFilter.status.value,
        layer: this.logFilter.layer.value,
        spec: this.logFilter.spec.value
      }
      if (this.searchQuery) {
        query.search = this.searchQuery
      }
      this.$router.replace({ query })
    },
    copyToClipboard(version) {
      const url = `${window.location.origin}/firmware?category=any&custom=any&layer=any&search=${version}&status=any`
      navigator.clipboard.writeText(url).then(() => {
        console.log('success', 'URL Copied', 'The URL has been copied to your clipboard.')
      }).catch(err => {
        console.error('error', 'Copy Failed', 'Failed to copy the URL.')
      })
    },
    isValidSpec(value, opts) {
      return opts.some(opt => opt.value === value);
    },
    compareVersions(version1, version2) {
      // Remove 'V' prefix and normalize version strings
      const normalize = (v) => {
        if (!v) return '0.0.0'
        return v.replace(/^V/i, '').replace(/,/g, '.').split('.').map(n => {
          const num = parseInt(n, 10)
          return isNaN(num) ? 0 : num
        })
      }

      const v1Parts = normalize(version1)
      const v2Parts = normalize(version2)
      const maxLength = Math.max(v1Parts.length, v2Parts.length)

      for (let i = 0; i < maxLength; i++) {
        const part1 = v1Parts[i] || 0
        const part2 = v2Parts[i] || 0

        if (part1 > part2) return 1
        if (part1 < part2) return -1
      }

      return 0
    },
    isVersionGreaterOrEqual(firmwareVersion, minimaFw) {
      if (!minimaFw || minimaFw.trim() === '') return true

      // Handle multiple minimum firmware versions (comma-separated)
      const minimaVersions = minimaFw.split(',').map(v => v.trim())

      // For multiple versions, check if firmware version exactly matches any of them
      // For single version, check if firmware version is >= minimum version
      if (minimaVersions.length > 1) {
        return minimaVersions.some(minVersion => {
          return this.compareVersions(firmwareVersion, minVersion) === 0
        })
      } else {
        return this.compareVersions(firmwareVersion, minimaVersions[0]) >= 0
      }
    },
    getCompatibleMibEntries(firmware) {
      if (!this.mibEntries || this.mibEntries.length === 0) return {}

      const compatibleMibEntries = this.mibEntries
        .filter(mib => {
          // Category must match
          if (mib.category !== firmware.category) return false

          // Vendor/custom must match (prevent NEC MIB binding to Lantech firmware, etc.)
          if (mib.custom !== firmware.custom) return false

          // Firmware version must be >= minimaFw
          if (!this.isVersionGreaterOrEqual(firmware.version, mib.minimaFw)) return false

          return true
        })
        .reduce((acc, mib) => {
          acc[mib.custom] = {
            version: mib.version,
            url: mib.url
          }
          return acc
        }, {})

      console.log('compatibleMibEntries', compatibleMibEntries)
      return compatibleMibEntries
    },
    getObjectSize(obj) {
      var size = Object.keys(obj).length
      console.log('size', size)
      return size
    }
  },
  watch: {
    logFilter: {
      deep: true,
      handler: function (nv) {
        this.currPage = 1
        this.currPaginationSec = 1
        this.updateQueryParams()
      }
    },
    searchQuery: function (newQuery) {
      this.updateQueryParams()
    },
    firmwareLoaded (val) {
      if (val) this.$refs.spinner.hide()
    },
    expandAll (newVal) {
      if (newVal) this.prefetchVisibleInternalLogs()
    },
    parseSpec: function(newSpec) {
      this.generalLog = newSpec.generalLog
      this.logFilter.spec.opts = [...newSpec.parsed]
      this.logFilter.spec.opts.unshift({label: 'Any', value: 'any'}, {label: 'General', value: 'general'})

      if (this.initSpec === '') return
      if (this.logFilter.spec.opts.length >= 2 && this.isValidSpec(this.initSpec, this.logFilter.spec.opts)) {
        this.logFilter.spec.value = this.initSpec
        this.initSpec = ''
      } else if (this.logFilter.spec.opts.length >= 3 && !this.isValidSpec(this.initSpec, this.logFilter.spec.opts)) {
        this.logFilter.spec.value = 'any'
        this.initSpec = ''
      } else {
        this.logFilter.spec.value = 'any'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../scss/_varaibles.scss';
@import '../../scss/_mixin.scss';
// .container{
//   max-width: 1150px;
// }
.upload_modal .form_label, .total, .function_bar .upload{
  text-align: right;
}
.function_bar {
  .upload{
    font-size: 20px;
  }
}
.form_label{
  padding: 5px 15px;
  white-space: nowrap;
}
.control_label{
  padding-right: 5px;
}

.text-vcenter {
  vertical-align: middle;
}

.upload_modal{
  .download{
    margin-left: -9px;
    margin-right: 9px;
  }
  .form-group{
    margin-bottom: 3px;
  }
  .form-group.larger_form_group{
    margin-bottom: 7px;
  }
}
.action_buttons{

}
.log_table{
  td {
    padding: 15px;
  }
  .media-top{
    display: flex;
    align-items: flex-start;
    .media-top__info {
      flex: 1 1 auto;
      min-width: 0;
      .version-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
      .time {
        display: block;
        margin-top: -4px;
        margin-bottom: 4px;
      }
    }
    .action_buttons {
      flex-shrink: 0;
      padding: 4px 0;
    }
  }
  .version{
    display: inline-block;
    // width: 130px;
    padding:3px 7px 3px 0px;
    font-size: 20px;
  }
  .time{
    color: #d7d7d7;
    padding-right:5px;
    .glyphicon{
      font-size: 10px;
      cursor: default;
      padding-right:5px;
    }
    span{
      font-size: 12px;
    }
  }
  span.download{
    cursor:pointer;
    span{
      font-size: 14px;
    }
  }
}
textarea{
  min-height: 200px;
  resize: vertical;
}
.warning{
  padding: 3px 5px;
  color: #fff;
  background-color: #f00;
}
.single_log{
  position: relative;
  padding-right: 0px !important;
  border-right: none;
}
.badge_group{
  position: relative;
  min-width: 65px;
  overflow: hidden;
  border-left: none;
}
.customized__badge{
  &.develop{
    @include genRightCornerBadge(50px, 18px, 14px, $warning, #000);
    right:-52px;
  }
  &.release{
    @include genRightCornerBadge(50px, 18px, 14px, $success, #fff);
    right:-48px;
  }
}
.error{
  border:2px solid #e33;
}
.err_msg{
  padding-right: 7px;
  padding-left: 7px;
  & span{
    display: inline-block;
    white-space: nowrap;
    line-height: 30px;
    font-size: 12px;
    width:100%;
    height:30px;
    background-color: #e33;
    color: #fff;
    padding: 0px 7px;
  }
}
.copy-icon {
  cursor: pointer;
  &:hover {
    color: #007bff;
  }
}
</style>



// WEBPACK FOOTER //
// Firmware.vue?34594436